<template>
  <ReportsPage
    :product="product"
    :product-data="productData"
    :forecast-subscription="forecastSubscription"
    hide-price-assessments-tab
  >
    <NuxtPage
      :product="product"
      :product-data="productData"
      :forecast-subscription="forecastSubscription"
    />
  </ReportsPage>
</template>

<script setup lang="ts">
import {
  FLUORSPAR,
  MARKET,
  SUBSCRIPTION_FORECASTS_FLUORSPAR,
} from '~/constants/services/constants'
import fluorsparData from '~/constants/data-reports/fluorspar'
import ReportsPage from '~/components/market/ReportsPage.vue'

definePageMeta({ layout: 'services' })

const product = ref(FLUORSPAR)
const productData = ref(fluorsparData)
const forecastSubscription = ref(SUBSCRIPTION_FORECASTS_FLUORSPAR)

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${FLUORSPAR.name} Data and Reports`,
})
useHead(seo)
</script>
